import { useEffect, useRef } from 'react';
import * as notify from './notify';
import { soundEnabled } from './sound';

/** On the rising edge of `isMyTurn`: chime and flash the tab title until the turn passes or the tab is focused. */
export function useTurnNotification(isMyTurn: boolean, baseTitle: string): void {
  const flasher = useRef<notify.TitleFlasher | null>(null);
  const was = useRef(false);
  useEffect(() => {
    flasher.current ??= notify.createTitleFlasher(baseTitle);
    const f = flasher.current;
    if (isMyTurn && !was.current) {
      if (soundEnabled()) notify.beep();
      if (!document.hasFocus()) f.start();   // the focus listener below stops the flashing as soon as the tab is looked at
    }
    if (!isMyTurn) f.stop();
    was.current = isMyTurn;
    const onFocus = (): void => { if (isMyTurn) f.stop(); };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [isMyTurn, baseTitle]);
  useEffect(() => () => flasher.current?.stop(), []);
}
